import { useSelector } from 'react-redux';
import { useTelegramApp } from './useTelegramApp';

/**
 * Хук для проверки готовности аутентификации
 * Возвращает true когда аутентификация завершена (успешно или неуспешно)
 */
export const useAuthReady = () => {
    const user = useSelector(state => state.auth.user);
    const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
    const { isReady } = useTelegramApp();
    
    // В Telegram WebApp ждем готовности WebApp
    if (window.Telegram?.WebApp) {
        return isReady;
    }
    
    // В браузере считаем готовым если:
    // 1. Есть пользователь (успешная аутентификация)
    // 2. Или точно известно что пользователь не авторизован (неуспешная аутентификация)
    return isAuthenticated !== null;
};

/**
 * Хук для проверки готовности аутентификации с пользователем
 * Возвращает true только если пользователь авторизован
 */
export const useAuthReadyWithUser = () => {
    const user = useSelector(state => state.auth.user);
    const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
    const { isReady } = useTelegramApp();
    
    // В Telegram WebApp ждем готовности WebApp И наличия пользователя
    if (window.Telegram?.WebApp) {
        return isReady && !!user;
    }
    
    // В браузере ждем завершения аутентификации И наличия пользователя
    return isAuthenticated && !!user;
};
